const SCREEN = {
  USAGE_SUMMARY: 'Usage Summary',
  RECEIPT: 'Receipt',
  PLUS_CONTRACT: 'Plus Contract',
  PLUS_CONTRACTS: 'Plus Contracts',
};

const ITEM = {
  CONTRACT: 'Contract',
  FAQ: 'FAQ',
  CLOSE: 'Close',
  RECENT_SETTLEMENT_CHARGE: 'Recent Settlement Charge',
  CHARGE: 'Charge',
  MONTHLY_BREAKDOWN_TAB: 'Monthly Breakdown month tab',
  MULTIPAY_CONTRACTS: 'Multipay Contracts',
  CHOATOBARAI_CONTRACTS: 'Choatobarai Contracts',
  UNCAPTURED: 'Uncaptured',
  BILL: 'Bill',
  PAY_NOW: 'PayNow',
  BANK_WIRE: 'Bank Wire',
};

const ACTION = {
  PAGE_VIEW: 'Page View',
  CLICK: 'Click',
};

export { ACTION, ITEM, SCREEN };
